import Step9 from '@/Classes/FollowUp/FollowUpPatint';
import Vue from 'vue';
export default {
  data() {
    return {
      stomach: require('@/assets/images/stomach.png'),
      patientBrainStrokeExaminationDetailTypeList: [
        { title: '0 – اندام هیچ حرکتی ندارد', id: 0 },
        {
          title: '1 – حرکت غیر ارادی، فاسیکولاسیون یا حرکت ارادی درجا دارد',
          id: 1,
        },
        {
          title: '2 – بدون غلبه بر جاذبه اندام را در سطح افقی جابجا می کند.',
          id: 2,
        },
        {
          title: '3 – می تواند بر خلاف جاذبه اندام را بالا بیاورد ولی توان غلبه بر مقاومت را ندارد',
          id: 3,
        },
        {
          title: '4 – شرایط امتیاز 3 به همراه با غلبه بر مقاومت ولی توان کمتر از نرمال',
          id: 4,
        },
        { title: '5 – توان نرمال', id: 5 },
      ],
      patientMediacalExamination: new Step9.Step9(
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        '',
        '',
        null,
        null,
        null,
        '',
        null,
        [],
        new Step9.PatientBrainStrokeExaminationDetail(null, null, null, null),
        new Step9.PatientPupilExamination(null, null, null, null, null, null, null, null),
        new Step9.PatientRespiratorySoundDetail(null, null, null, null, null, null, null, null),
      ),
      tempLastFoodDate: '',
      showLastFoodDate: false,
      allStoomakePartNumbers: [
        { id: 1, title: 1 },
        { id: 2, title: 2 },
        { id: 3, title: 3 },
        { id: 4, title: 4 },
        { id: 5, title: 5 },
        { id: 6, title: 6 },
        { id: 7, title: 7 },
        { id: 8, title: 8 },
        { id: 9, title: 9 },
      ],
      selectedPart: null,
      // selectedStoomakeProblem: null,
      selectedStoomakeProblems: [],
      stoomakeModal: false,
      allStoomakeProblems: [],
    };
  },
  methods: {
    clearDateTime: function (type) {
      if (type == 'lastFoodDate') {
        this.showLastFoodDate = false;
        this.patientMediacalExamination.lastFoodDate = '';
        this.tempLastFoodDate = '';
      }
    },
    dateTimeChange: function (type) {
      if (type == 'lastFoodDate') {
        if (this.patientMediacalExamination.lastFoodDate) {
          this.tempLastFoodDate = Vue.moment(this.patientMediacalExamination.lastFoodDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      }
    },
    heartMonitoringChange: function () {
      this.patientMediacalExamination.heartRhythmId = null;
      this.patientMediacalExamination.heartSoundId = null;
    },
    showStoomakeModal: function () {
      this.getListOfAbdomenExaminationsForOther();
      this.stoomakeModal = true;
    },
    addStomakeProblem: function () {
      const newItems = this.selectedStoomakeProblems.filter(item => {
        return !this.allStoomakeProblems.some(
          existing => existing.title === item.title && existing.part === this.selectedPart
        );
      });

      newItems.forEach(item => {
        this.allStoomakeProblems.push({
          id: this.allStoomakeProblems.length + 1,
          title: item?.title ?? '',
          part: this.selectedPart,
        });
      });

      const newIds = this.selectedStoomakeProblems.map(item => item.id);
      const partNumber = Number(this.selectedPart);

      const existingIndex = this.patientMediacalExamination.patientAbdominalExaminations.findIndex(
        existing => existing.partNumber === partNumber
      );

      if (existingIndex !== -1) {
        const existingIds = this.patientMediacalExamination.patientAbdominalExaminations[existingIndex].abdomenExaminationId || [];

        const mergedIds = [...new Set([...existingIds, ...newIds])];

        this.patientMediacalExamination.patientAbdominalExaminations[existingIndex].abdomenExaminationId = mergedIds;
      } else {
        this.patientMediacalExamination.patientAbdominalExaminations.push({
          partNumber: partNumber,
          abdomenExaminationId: newIds,
        });
      }

      this.stoomakeModal = false;
      this.selectedPart = null;
      this.selectedStoomakeProblems = [];
    },
    removeStoomakeProblem: function (id) {
      const index1 = this.allStoomakeProblems.findIndex(item => item.id === id);
      if (index1 !== -1) {
        this.allStoomakeProblems.splice(index1, 1);
      }

      const index2 = this.patientMediacalExamination.patientAbdominalExaminations.findIndex(
        item => item.partNumber === id
      );
      if (index2 !== -1) {
        this.patientMediacalExamination.patientAbdominalExaminations.splice(index2, 1);
      }
    },
    cancelAddStomakeProblem: function () {
      this.stoomakeModal = false;
      this.selectedPart = null;
      this.selectedStoomakeProblems = [];
    },
    addPatientMedicalExamination: function () {
      this.patientMediacalExamination.patientId = this.patientId;
      if (
        !this.patientMediacalExamination.patientBrainStrokeExaminationDetail.rightHand &&
        !this.patientMediacalExamination.patientBrainStrokeExaminationDetail.leftHand &&
        !this.patientMediacalExamination.patientBrainStrokeExaminationDetail.rightLeg &&
        !this.patientMediacalExamination.patientBrainStrokeExaminationDetail.leftLeg
      ) {
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail = null;
      }
      if (this.patientMediacalExamination.patientAbdominalExaminations.length == 0) {
        this.patientMediacalExamination.patientAbdominalExaminations = null;
      }
      if (
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightFineRale == null &&
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftFineRale == null &&
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightCoarseRale == null &&
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftCoarseRale == null &&
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightWheeze == null &&
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftWheeze == null &&
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightSoundReduction == null &&
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftSoundReduction == null
      ) {
        this.patientMediacalExamination.patientRespiratorySoundDetail = null;
      }
      if (
        this.patientMediacalExamination.patientPupilExamination.rightNormal == null &&
        this.patientMediacalExamination.patientPupilExamination.leftNormal == null &&
        this.patientMediacalExamination.patientPupilExamination.rightDilate == null &&
        this.patientMediacalExamination.patientPupilExamination.leftDilate == null &&
        this.patientMediacalExamination.patientPupilExamination.rightMiotic == null &&
        this.patientMediacalExamination.patientPupilExamination.leftMiotic == null &&
        this.patientMediacalExamination.patientPupilExamination.rightNoAnswer == null &&
        this.patientMediacalExamination.patientPupilExamination.leftNoAnswer == null
      ) {
        this.patientMediacalExamination.patientPupilExamination = null;
      }
      if (this.patientMediacalExamination.lastFoodDate == '') {
        this.patientMediacalExamination.lastFoodDate = null;
      }
      this.addPatientMedicalExaminationFunction(this.patientMediacalExamination);
    },
    patientMedicalExaminationAdded: function () {

      try {
        this.$root.$refs.FollowUpPatient.changeTab3Step(2, true);
      } catch (error) { console.log("A error :", error); }
      try {
        const id_nextDialog = (this.localFlagShowForm == 1 || this.localFlagShowForm == 2) ? 8 : 9
        this.$root.$refs.ReportFormFollowUp.reloadApiFun(7, this.isGoToNext, id_nextDialog);
        this.isGoToNext = false
      } catch (error) { console.log("A error :", error); }
    },
    setData: function (data) {
      this.allStoomakeProblems = [];
      this.patientMediacalExamination.patientAbdominalExaminations = [];
      this.patientMediacalExamination.hadHeartMonitoring = data.hadHeartMonitoring;
      this.patientMediacalExamination.lastFood = data.lastFood;
      if (data.lastFoodDate) {
        this.patientMediacalExamination.lastFoodDate = data.lastFoodDate;
        this.tempLastFoodDate = Vue.moment(data.lastFoodDate).format('HH:mm:ss jYYYY-jMM-jDD');
      } else {
        this.patientMediacalExamination.lastFoodDate = '';
      }
      this.patientMediacalExamination.hasNystagmus = data.hasNystagmus;
      this.patientMediacalExamination.hasVaginalBleeding = data.hasVaginalBleeding;
      this.patientMediacalExamination.hasEyeDeviation = data.hasEyeDeviation;
      this.patientMediacalExamination.otherSymptoms = data.otherSymptoms;
      this.patientMediacalExamination.heartRhythmId = data.heartRhythm ? data.heartRhythm.id : null;
      this.patientMediacalExamination.heartSoundId = data.heartSound ? data.heartSound.id : null;
      this.patientMediacalExamination.pulseQualityId = data.pulseQuality
        ? data.pulseQuality.id
        : null;
      this.patientMediacalExamination.pulseRhythmId = data.pulseRhythm ? data.pulseRhythm.id : null;
      this.patientMediacalExamination.respiratorySoundId = data.respiratorySound
        ? data.respiratorySound.id
        : null;
      this.patientMediacalExamination.skinTurgorId = data.skinTurgor ? data.skinTurgor.id : null;
      this.patientMediacalExamination.skinTemperatureId = data.skinTemperature
        ? data.skinTemperature.id
        : null;
      this.patientMediacalExamination.skinExaminationId = data.skinExamination
        ? data.skinExamination.id
        : null;

      let counter = 0;
      data.patientAbdominalExaminations.forEach(item => {
        this.patientMediacalExamination.patientAbdominalExaminations.push({
          partNumber: Number(item.partNumber),
          abdomenExaminationId: item.abdomenExaminations?.map(exam => exam.id) || [],
        });

        item.abdomenExaminations?.forEach(exam => {
          counter++;
          this.allStoomakeProblems.push({
            id: counter,
            title: exam.title,
            part: item.partNumber,
          });
        });
      });


      if (data.patientBrainStrokeExaminationDetail) {
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.rightHand =
          data.patientBrainStrokeExaminationDetail.rightHand;
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.leftHand =
          data.patientBrainStrokeExaminationDetail.leftHand;
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.rightLeg =
          data.patientBrainStrokeExaminationDetail.rightLeg;
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.leftLeg =
          data.patientBrainStrokeExaminationDetail.leftLeg;
      } else {
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.rightHand = null;
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.leftHand = null;
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.rightLeg = null;
        this.patientMediacalExamination.patientBrainStrokeExaminationDetail.leftLeg = null;
      }
      if (data.patientPupilExamination) {
        this.patientMediacalExamination.patientPupilExamination.rightNormal =
          data.patientPupilExamination.rightNormal;
        this.patientMediacalExamination.patientPupilExamination.leftNormal =
          data.patientPupilExamination.leftNormal;
        this.patientMediacalExamination.patientPupilExamination.rightDilate =
          data.patientPupilExamination.rightDilate;
        this.patientMediacalExamination.patientPupilExamination.leftDilate =
          data.patientPupilExamination.leftDilate;
        this.patientMediacalExamination.patientPupilExamination.rightMiotic =
          data.patientPupilExamination.rightMiotic;
        this.patientMediacalExamination.patientPupilExamination.leftMiotic =
          data.patientPupilExamination.leftMiotic;
        this.patientMediacalExamination.patientPupilExamination.rightNoAnswer =
          data.patientPupilExamination.rightNoAnswer;
        this.patientMediacalExamination.patientPupilExamination.leftNoAnswer =
          data.patientPupilExamination.leftNoAnswer;
      } else {
        this.patientMediacalExamination.patientPupilExamination.rightNormal = null;
        this.patientMediacalExamination.patientPupilExamination.leftNormal = null;
        this.patientMediacalExamination.patientPupilExamination.rightDilate = null;
        this.patientMediacalExamination.patientPupilExamination.leftDilate = null;
        this.patientMediacalExamination.patientPupilExamination.rightMiotic = null;
        this.patientMediacalExamination.patientPupilExamination.leftMiotic = null;
        this.patientMediacalExamination.patientPupilExamination.rightNoAnswer = null;
        this.patientMediacalExamination.patientPupilExamination.leftNoAnswer = null;
      }
      if (data.patientRespiratorySoundDetail) {
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightFineRale =
          data.patientRespiratorySoundDetail.rightFineRale;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftFineRale =
          data.patientRespiratorySoundDetail.leftFineRale;
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightCoarseRale =
          data.patientRespiratorySoundDetail.rightCoarseRale;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftCoarseRale =
          data.patientRespiratorySoundDetail.leftCoarseRale;
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightWheeze =
          data.patientRespiratorySoundDetail.rightWheeze;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftWheeze =
          data.patientRespiratorySoundDetail.leftWheeze;
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightSoundReduction =
          data.patientRespiratorySoundDetail.rightSoundReduction;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftNoAnswer =
          data.patientRespiratorySoundDetail.leftSoundReduction;
      } else {
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightFineRale = null;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftFineRale = null;
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightCoarseRale = null;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftCoarseRale = null;
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightWheeze = null;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftWheeze = null;
        this.patientMediacalExamination.patientRespiratorySoundDetail.rightSoundReduction = null;
        this.patientMediacalExamination.patientRespiratorySoundDetail.leftSoundReduction = null;
      }
    },
    backToStep8: function () {
      this.$root.$refs.FollowUpPatient.changeTab(2);
      this.$root.$refs.FollowUpPatient.changeTab2Step(4, true);
    },
  },
};
